//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import moment from 'moment';
import { ClientConfig, AuthorizedClientBase } from "msg-swagger"

export class PropertyConfigClient extends AuthorizedClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(aggregateAcronym: string | null): Promise<PropertyAggregateDTO> {
        let url_ = this.baseUrl + "/api/PropertyConfig/aggregate/{aggregateAcronym}";
        if (aggregateAcronym === undefined || aggregateAcronym === null)
            throw new Error("The parameter 'aggregateAcronym' must be defined.");
        url_ = url_.replace("{aggregateAcronym}", encodeURIComponent("" + aggregateAcronym));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<PropertyAggregateDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertyAggregateDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PropertyAggregateDTO>(null as any);
    }

    bulkMutation(dto: MutationDTO): Promise<void> {
        let url_ = this.baseUrl + "/api/PropertyConfig/bulk-mutation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkMutation(_response);
        });
    }

    protected processBulkMutation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class PropertyAggregateDTO implements IPropertyAggregateDTO {
    acronym?: string | undefined;
    name?: string | undefined;
    sets?: PropertySetDTO[] | undefined;

    constructor(data?: IPropertyAggregateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.acronym = _data["acronym"];
            this.name = _data["name"];
            if (Array.isArray(_data["sets"])) {
                this.sets = [] as any;
                for (let item of _data["sets"])
                    this.sets!.push(PropertySetDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PropertyAggregateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyAggregateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acronym"] = this.acronym;
        data["name"] = this.name;
        if (Array.isArray(this.sets)) {
            data["sets"] = [];
            for (let item of this.sets)
                data["sets"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPropertyAggregateDTO {
    acronym?: string | undefined;
    name?: string | undefined;
    sets?: PropertySetDTO[] | undefined;
}

export class PropertySetDTO implements IPropertySetDTO {
    acronym?: string | undefined;
    name?: string | undefined;
    propertyConfigurations?: BasePropertyConfig[] | undefined;
    usages?: PropertySetUsageDTO[] | undefined;

    constructor(data?: IPropertySetDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.acronym = _data["acronym"];
            this.name = _data["name"];
            if (Array.isArray(_data["propertyConfigurations"])) {
                this.propertyConfigurations = [] as any;
                for (let item of _data["propertyConfigurations"])
                    this.propertyConfigurations!.push(BasePropertyConfig.fromJS(item));
            }
            if (Array.isArray(_data["usages"])) {
                this.usages = [] as any;
                for (let item of _data["usages"])
                    this.usages!.push(PropertySetUsageDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PropertySetDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PropertySetDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acronym"] = this.acronym;
        data["name"] = this.name;
        if (Array.isArray(this.propertyConfigurations)) {
            data["propertyConfigurations"] = [];
            for (let item of this.propertyConfigurations)
                data["propertyConfigurations"].push(item.toJSON());
        }
        if (Array.isArray(this.usages)) {
            data["usages"] = [];
            for (let item of this.usages)
                data["usages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPropertySetDTO {
    acronym?: string | undefined;
    name?: string | undefined;
    propertyConfigurations?: BasePropertyConfig[] | undefined;
    usages?: PropertySetUsageDTO[] | undefined;
}

export abstract class BasePropertyConfig implements IBasePropertyConfig {
    acronym?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    isHidden!: boolean;
    useInFilters!: boolean;
    isReadonly!: boolean;
    sortKey?: number | undefined;

    protected _discriminator: string;

    constructor(data?: IBasePropertyConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BasePropertyConfig";
    }

    init(_data?: any) {
        if (_data) {
            this.acronym = _data["acronym"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isHidden = _data["isHidden"];
            this.useInFilters = _data["useInFilters"];
            this.isReadonly = _data["isReadonly"];
            this.sortKey = _data["sortKey"];
        }
    }

    static fromJS(data: any): BasePropertyConfig {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "IntPropertyConfig") {
            let result = new IntPropertyConfig();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "IntSetPropertyConfig") {
            let result = new IntSetPropertyConfig();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "DoublePropertyConfig") {
            let result = new DoublePropertyConfig();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "DoubleSetPropertyConfig") {
            let result = new DoubleSetPropertyConfig();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "StringPropertyConfig") {
            let result = new StringPropertyConfig();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "StringSetPropertyConfig") {
            let result = new StringSetPropertyConfig();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "BooleanPropertyConfig") {
            let result = new BooleanPropertyConfig();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "BooleanSetPropertyConfig") {
            let result = new BooleanSetPropertyConfig();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "DateTimePropertyConfig") {
            let result = new DateTimePropertyConfig();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "DateTimeSetPropertyConfig") {
            let result = new DateTimeSetPropertyConfig();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "GuidPropertyConfig") {
            let result = new GuidPropertyConfig();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "GuidSetPropertyConfig") {
            let result = new GuidSetPropertyConfig();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BasePropertyConfig' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["acronym"] = this.acronym;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isHidden"] = this.isHidden;
        data["useInFilters"] = this.useInFilters;
        data["isReadonly"] = this.isReadonly;
        data["sortKey"] = this.sortKey;
        return data;
    }
}

export interface IBasePropertyConfig {
    acronym?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    isHidden: boolean;
    useInFilters: boolean;
    isReadonly: boolean;
    sortKey?: number | undefined;
}

export class IntPropertyConfig extends BasePropertyConfig implements IIntPropertyConfig {
    type?: PropertyType;
    minValue?: number | undefined;
    maxValue?: number | undefined;
    resolution?: number;
    unit?: string | undefined;
    domain?: DomainDTO | undefined;
    referencedItem?: string | undefined;

    constructor(data?: IIntPropertyConfig) {
        super(data);
        this._discriminator = "IntPropertyConfig";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            this.minValue = _data["minValue"];
            this.maxValue = _data["maxValue"];
            this.resolution = _data["resolution"];
            this.unit = _data["unit"];
            this.domain = _data["domain"] ? DomainDTO.fromJS(_data["domain"]) : <any>undefined;
            this.referencedItem = _data["referencedItem"];
        }
    }

    static fromJS(data: any): IntPropertyConfig {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "IntSetPropertyConfig") {
            let result = new IntSetPropertyConfig();
            result.init(data);
            return result;
        }
        let result = new IntPropertyConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["minValue"] = this.minValue;
        data["maxValue"] = this.maxValue;
        data["resolution"] = this.resolution;
        data["unit"] = this.unit;
        data["domain"] = this.domain ? this.domain.toJSON() : <any>undefined;
        data["referencedItem"] = this.referencedItem;
        super.toJSON(data);
        return data;
    }
}

export interface IIntPropertyConfig extends IBasePropertyConfig {
    type?: PropertyType;
    minValue?: number | undefined;
    maxValue?: number | undefined;
    resolution?: number;
    unit?: string | undefined;
    domain?: DomainDTO | undefined;
    referencedItem?: string | undefined;
}

export enum PropertyType {
    Int = 0,
    IntSet = 1,
    Double = 2,
    DoubleSet = 3,
    String = 4,
    StringSet = 5,
    Boolean = 6,
    BooleanSet = 7,
    DateTime = 8,
    DateTimeSet = 9,
    Guid = 10,
    GuidSet = 11,
}

export class DomainDTO implements IDomainDTO {
    acronym?: string | undefined;
    description?: string | undefined;
    values?: DomainValueDTO[] | undefined;

    constructor(data?: IDomainDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.acronym = _data["acronym"];
            this.description = _data["description"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(DomainValueDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DomainDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DomainDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acronym"] = this.acronym;
        data["description"] = this.description;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDomainDTO {
    acronym?: string | undefined;
    description?: string | undefined;
    values?: DomainValueDTO[] | undefined;
}

export class DomainValueDTO implements IDomainValueDTO {
    id!: number;
    value?: string | undefined;
    description?: string | undefined;
    sortOrder!: number;

    constructor(data?: IDomainValueDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.description = _data["description"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): DomainValueDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DomainValueDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["description"] = this.description;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IDomainValueDTO {
    id: number;
    value?: string | undefined;
    description?: string | undefined;
    sortOrder: number;
}

export class IntSetPropertyConfig extends IntPropertyConfig implements IIntSetPropertyConfig {
    type?: PropertyType;

    constructor(data?: IIntSetPropertyConfig) {
        super(data);
        this._discriminator = "IntSetPropertyConfig";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): IntSetPropertyConfig {
        data = typeof data === 'object' ? data : {};
        let result = new IntSetPropertyConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        super.toJSON(data);
        return data;
    }
}

export interface IIntSetPropertyConfig extends IIntPropertyConfig {
    type?: PropertyType;
}

export class DoublePropertyConfig extends BasePropertyConfig implements IDoublePropertyConfig {
    type?: PropertyType;
    minValue?: number | undefined;
    maxValue?: number | undefined;
    resolution?: number;
    unit?: string | undefined;
    isInterval?: boolean;

    constructor(data?: IDoublePropertyConfig) {
        super(data);
        this._discriminator = "DoublePropertyConfig";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            this.minValue = _data["minValue"];
            this.maxValue = _data["maxValue"];
            this.resolution = _data["resolution"];
            this.unit = _data["unit"];
            this.isInterval = _data["isInterval"];
        }
    }

    static fromJS(data: any): DoublePropertyConfig {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "DoubleSetPropertyConfig") {
            let result = new DoubleSetPropertyConfig();
            result.init(data);
            return result;
        }
        let result = new DoublePropertyConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["minValue"] = this.minValue;
        data["maxValue"] = this.maxValue;
        data["resolution"] = this.resolution;
        data["unit"] = this.unit;
        data["isInterval"] = this.isInterval;
        super.toJSON(data);
        return data;
    }
}

export interface IDoublePropertyConfig extends IBasePropertyConfig {
    type?: PropertyType;
    minValue?: number | undefined;
    maxValue?: number | undefined;
    resolution?: number;
    unit?: string | undefined;
    isInterval?: boolean;
}

export class DoubleSetPropertyConfig extends DoublePropertyConfig implements IDoubleSetPropertyConfig {
    type?: PropertyType;

    constructor(data?: IDoubleSetPropertyConfig) {
        super(data);
        this._discriminator = "DoubleSetPropertyConfig";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): DoubleSetPropertyConfig {
        data = typeof data === 'object' ? data : {};
        let result = new DoubleSetPropertyConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        super.toJSON(data);
        return data;
    }
}

export interface IDoubleSetPropertyConfig extends IDoublePropertyConfig {
    type?: PropertyType;
}

export class StringPropertyConfig extends BasePropertyConfig implements IStringPropertyConfig {
    type?: PropertyType;
    domain?: DomainDTO | undefined;

    constructor(data?: IStringPropertyConfig) {
        super(data);
        this._discriminator = "StringPropertyConfig";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            this.domain = _data["domain"] ? DomainDTO.fromJS(_data["domain"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StringPropertyConfig {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "StringSetPropertyConfig") {
            let result = new StringSetPropertyConfig();
            result.init(data);
            return result;
        }
        let result = new StringPropertyConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["domain"] = this.domain ? this.domain.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IStringPropertyConfig extends IBasePropertyConfig {
    type?: PropertyType;
    domain?: DomainDTO | undefined;
}

export class StringSetPropertyConfig extends StringPropertyConfig implements IStringSetPropertyConfig {
    type?: PropertyType;

    constructor(data?: IStringSetPropertyConfig) {
        super(data);
        this._discriminator = "StringSetPropertyConfig";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): StringSetPropertyConfig {
        data = typeof data === 'object' ? data : {};
        let result = new StringSetPropertyConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        super.toJSON(data);
        return data;
    }
}

export interface IStringSetPropertyConfig extends IStringPropertyConfig {
    type?: PropertyType;
}

export class BooleanPropertyConfig extends BasePropertyConfig implements IBooleanPropertyConfig {
    type?: PropertyType;

    constructor(data?: IBooleanPropertyConfig) {
        super(data);
        this._discriminator = "BooleanPropertyConfig";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): BooleanPropertyConfig {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "BooleanSetPropertyConfig") {
            let result = new BooleanSetPropertyConfig();
            result.init(data);
            return result;
        }
        let result = new BooleanPropertyConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        super.toJSON(data);
        return data;
    }
}

export interface IBooleanPropertyConfig extends IBasePropertyConfig {
    type?: PropertyType;
}

export class BooleanSetPropertyConfig extends BooleanPropertyConfig implements IBooleanSetPropertyConfig {
    type?: PropertyType;

    constructor(data?: IBooleanSetPropertyConfig) {
        super(data);
        this._discriminator = "BooleanSetPropertyConfig";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): BooleanSetPropertyConfig {
        data = typeof data === 'object' ? data : {};
        let result = new BooleanSetPropertyConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        super.toJSON(data);
        return data;
    }
}

export interface IBooleanSetPropertyConfig extends IBooleanPropertyConfig {
    type?: PropertyType;
}

export class DateTimePropertyConfig extends BasePropertyConfig implements IDateTimePropertyConfig {
    type?: PropertyType;
    minValue?: moment.Moment | undefined;
    maxValue?: moment.Moment | undefined;
    resolution?: DateTimeResolution;

    constructor(data?: IDateTimePropertyConfig) {
        super(data);
        this._discriminator = "DateTimePropertyConfig";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            this.minValue = _data["minValue"] ? moment(_data["minValue"].toString()) : <any>undefined;
            this.maxValue = _data["maxValue"] ? moment(_data["maxValue"].toString()) : <any>undefined;
            this.resolution = _data["resolution"];
        }
    }

    static fromJS(data: any): DateTimePropertyConfig {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "DateTimeSetPropertyConfig") {
            let result = new DateTimeSetPropertyConfig();
            result.init(data);
            return result;
        }
        let result = new DateTimePropertyConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["minValue"] = this.minValue ? this.minValue.toISOString() : <any>undefined;
        data["maxValue"] = this.maxValue ? this.maxValue.toISOString() : <any>undefined;
        data["resolution"] = this.resolution;
        super.toJSON(data);
        return data;
    }
}

export interface IDateTimePropertyConfig extends IBasePropertyConfig {
    type?: PropertyType;
    minValue?: moment.Moment | undefined;
    maxValue?: moment.Moment | undefined;
    resolution?: DateTimeResolution;
}

export enum DateTimeResolution {
    Year = 0,
    Month = 1,
    Day = 2,
    Hour = 3,
    Minute = 4,
    Second = 5,
    Millisecond = 6,
}

export class DateTimeSetPropertyConfig extends DateTimePropertyConfig implements IDateTimeSetPropertyConfig {
    type?: PropertyType;

    constructor(data?: IDateTimeSetPropertyConfig) {
        super(data);
        this._discriminator = "DateTimeSetPropertyConfig";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): DateTimeSetPropertyConfig {
        data = typeof data === 'object' ? data : {};
        let result = new DateTimeSetPropertyConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        super.toJSON(data);
        return data;
    }
}

export interface IDateTimeSetPropertyConfig extends IDateTimePropertyConfig {
    type?: PropertyType;
}

export class GuidPropertyConfig extends BasePropertyConfig implements IGuidPropertyConfig {
    type?: PropertyType;
    referencedItem?: string | undefined;

    constructor(data?: IGuidPropertyConfig) {
        super(data);
        this._discriminator = "GuidPropertyConfig";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            this.referencedItem = _data["referencedItem"];
        }
    }

    static fromJS(data: any): GuidPropertyConfig {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "GuidSetPropertyConfig") {
            let result = new GuidSetPropertyConfig();
            result.init(data);
            return result;
        }
        let result = new GuidPropertyConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["referencedItem"] = this.referencedItem;
        super.toJSON(data);
        return data;
    }
}

export interface IGuidPropertyConfig extends IBasePropertyConfig {
    type?: PropertyType;
    referencedItem?: string | undefined;
}

export class GuidSetPropertyConfig extends GuidPropertyConfig implements IGuidSetPropertyConfig {
    type?: PropertyType;

    constructor(data?: IGuidSetPropertyConfig) {
        super(data);
        this._discriminator = "GuidSetPropertyConfig";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): GuidSetPropertyConfig {
        data = typeof data === 'object' ? data : {};
        let result = new GuidSetPropertyConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        super.toJSON(data);
        return data;
    }
}

export interface IGuidSetPropertyConfig extends IGuidPropertyConfig {
    type?: PropertyType;
}

export class PropertySetUsageDTO implements IPropertySetUsageDTO {
    setAcronym?: string | undefined;
    tenant?: string | undefined;
    tenantSetName?: string | undefined;

    constructor(data?: IPropertySetUsageDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.setAcronym = _data["setAcronym"];
            this.tenant = _data["tenant"];
            this.tenantSetName = _data["tenantSetName"];
        }
    }

    static fromJS(data: any): PropertySetUsageDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PropertySetUsageDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["setAcronym"] = this.setAcronym;
        data["tenant"] = this.tenant;
        data["tenantSetName"] = this.tenantSetName;
        return data;
    }
}

export interface IPropertySetUsageDTO {
    setAcronym?: string | undefined;
    tenant?: string | undefined;
    tenantSetName?: string | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions!: { [key: string]: any; };

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.extensions = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (<any>this.extensions)![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (<any>data["extensions"])[key] = (<any>this.extensions)[key];
            }
        }
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions: { [key: string]: any; };
}

export class MutationDTO implements IMutationDTO {
    aggregateAcronym?: string | undefined;
    aggregateName?: string | undefined;
    sets?: PropertySetDTO[] | undefined;
    domains?: DomainDTO[] | undefined;
    cleanupSetMembers!: boolean;

    constructor(data?: IMutationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.aggregateAcronym = _data["aggregateAcronym"];
            this.aggregateName = _data["aggregateName"];
            if (Array.isArray(_data["sets"])) {
                this.sets = [] as any;
                for (let item of _data["sets"])
                    this.sets!.push(PropertySetDTO.fromJS(item));
            }
            if (Array.isArray(_data["domains"])) {
                this.domains = [] as any;
                for (let item of _data["domains"])
                    this.domains!.push(DomainDTO.fromJS(item));
            }
            this.cleanupSetMembers = _data["cleanupSetMembers"];
        }
    }

    static fromJS(data: any): MutationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MutationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["aggregateAcronym"] = this.aggregateAcronym;
        data["aggregateName"] = this.aggregateName;
        if (Array.isArray(this.sets)) {
            data["sets"] = [];
            for (let item of this.sets)
                data["sets"].push(item.toJSON());
        }
        if (Array.isArray(this.domains)) {
            data["domains"] = [];
            for (let item of this.domains)
                data["domains"].push(item.toJSON());
        }
        data["cleanupSetMembers"] = this.cleanupSetMembers;
        return data;
    }
}

export interface IMutationDTO {
    aggregateAcronym?: string | undefined;
    aggregateName?: string | undefined;
    sets?: PropertySetDTO[] | undefined;
    domains?: DomainDTO[] | undefined;
    cleanupSetMembers: boolean;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}